import { Bell } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import useNotificationStore from '@/store/useNotificationStore'
import NotificationDropdown from './NotificationDropdown'
import { useState } from 'react'

/**
 * The notification bell icon with unread indicator.
 * Shows a badge with the unread count and opens a dropdown with notifications.
 *
 * @example
 * // Used in Navigation next to UserMenu
 * <NotificationBell />
 */
const NotificationBell = () => {
  const { unreadCount, fetchNotifications } = useNotificationStore()
  const [open, setOpen] = useState(false)

  const handleOpenChange = (isOpen) => {
    setOpen(isOpen)
    if (isOpen) {
      // Fetch full notifications when dropdown opens
      fetchNotifications()
    }
  }

  return (
    <Popover open={open} onOpenChange={handleOpenChange}>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="relative h-9 w-9"
          data-testid="notification-bell"
        >
          <Bell className="h-5 w-5" />
          {unreadCount > 0 && (
            <span
              className="absolute -top-1 -right-1 flex h-5 w-5 items-center justify-center rounded-full bg-red-500 text-xs text-white font-medium"
              data-testid="notification-badge"
            >
              {unreadCount > 99 ? '99+' : unreadCount}
            </span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-80 p-0 rounded-none" align="end">
        <NotificationDropdown onClose={() => setOpen(false)} />
      </PopoverContent>
    </Popover>
  )
}

export default NotificationBell
